class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.debouncedOnSubmit = this.debounce(this.onSubmitHandler.bind(this), 500);

    if (this.form) {
      this.form.addEventListener('input', this.debouncedOnSubmit);
      this.form.addEventListener('change', this.debouncedOnSubmit);
    }
  }

  // Utility: debounce to avoid spamming requests
  debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), wait);
    };
  }

  // Handles filter submission
  onSubmitHandler(event) {
    event.preventDefault();

    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();

    this.renderPage(searchParams);
  }

  // Fetches and replaces filtered products dynamically
  async renderPage(searchParams) {
    const url = `${window.location.pathname}?${searchParams}`;
    const currentProducts = document.querySelector('.collection_grid_template');
    const loader = this.createLoadingOverlay(currentProducts);

    try {
      loader.classList.add('active');

      const response = await fetch(url);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newProducts = doc.querySelector('.collection_grid_template');
      const newSidebar = doc.querySelector('.collection_sidebar');

      if (newProducts && currentProducts) {
        currentProducts.innerHTML = newProducts.innerHTML;
        currentProducts.classList.add('fade-in');
        setTimeout(() => currentProducts.classList.remove('fade-in'), 300);
      }

      // Optional: Replace filters if they change dynamically
      if (newSidebar) {
        const currentSidebar = document.querySelector('.collection_sidebar');
        if (currentSidebar) currentSidebar.innerHTML = newSidebar.innerHTML;
      }

      history.replaceState({}, '', url);
    } catch (err) {
      console.error('Facet filter update failed:', err);
    } finally {
      loader.classList.remove('active');
    }
  }

  // Small reusable overlay loader
  createLoadingOverlay(container) {
    let overlay = container.querySelector('.facet-loading-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'facet-loading-overlay';
      overlay.innerHTML = `<div class="spinner"></div>`;
      container.style.position = 'relative';
      container.appendChild(overlay);
    }
    return overlay;
  }
}

// Define the custom element
customElements.define('facet-filters-form', FacetFiltersForm);
